/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Settings_Ai_Actions_ResetsInputs */

const en_settings_ai_actions_resets = /** @type {(inputs: Settings_Ai_Actions_ResetsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Resets on ${i?.date}`)
};

const de_settings_ai_actions_resets = /** @type {(inputs: Settings_Ai_Actions_ResetsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Läuft am ${i?.date} ab`)
};

const fr_settings_ai_actions_resets = /** @type {(inputs: Settings_Ai_Actions_ResetsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Réinitialisation le ${i?.date}`)
};

const es_settings_ai_actions_resets = /** @type {(inputs: Settings_Ai_Actions_ResetsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Se reinicia el ${i?.date}`)
};

const it_settings_ai_actions_resets = /** @type {(inputs: Settings_Ai_Actions_ResetsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ripristina il ${i?.date}`)
};

const nl_settings_ai_actions_resets = /** @type {(inputs: Settings_Ai_Actions_ResetsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Reset op ${i?.date}`)
};

const pl_settings_ai_actions_resets = /** @type {(inputs: Settings_Ai_Actions_ResetsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Resetuje się ${i?.date}`)
};

const fi_settings_ai_actions_resets = /** @type {(inputs: Settings_Ai_Actions_ResetsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nollautuu ${i?.date}`)
};

const da_settings_ai_actions_resets = /** @type {(inputs: Settings_Ai_Actions_ResetsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nulstilles den ${i?.date}`)
};

const sv_settings_ai_actions_resets = /** @type {(inputs: Settings_Ai_Actions_ResetsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Återställs den ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Resets on {date}" |
*
* @param {Settings_Ai_Actions_ResetsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_ai_actions_resets = /** @type {((inputs: Settings_Ai_Actions_ResetsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Ai_Actions_ResetsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_ai_actions_resets(inputs)
	if (locale === "fr") return fr_settings_ai_actions_resets(inputs)
	if (locale === "es") return es_settings_ai_actions_resets(inputs)
	if (locale === "it") return it_settings_ai_actions_resets(inputs)
	if (locale === "nl") return nl_settings_ai_actions_resets(inputs)
	if (locale === "pl") return pl_settings_ai_actions_resets(inputs)
	if (locale === "fi") return fi_settings_ai_actions_resets(inputs)
	if (locale === "da") return da_settings_ai_actions_resets(inputs)
	if (locale === "sv") return sv_settings_ai_actions_resets(inputs)
	return en_settings_ai_actions_resets(inputs)
});